"use client";
import Image from "next/image";
import { useRef } from "react";
import { usePathname } from "next/navigation";
import { Button } from "../../shadcn/button";
import { Tooltip, TooltipContent, TooltipTrigger } from "../../shadcn/tooltip";
import { FloatingMenuItem } from "@/app/lib/features/floatingContent/floatingContent.types";
import useLiveSupport, { SipConfig } from "@/app/hooks/useLiveSupport";
import useAiCall from "@/app/hooks/useAiCall";
import useAuth from "@/app/lib/features/auth/auth.hook";
import { useRouter } from "next/navigation";
import { trackGeneric } from "@/app/lib/tracking/interactions";
import LiveSupportDialog from "./LiveSupportDialog";

const SUPPORT_SIP_CONFIG: SipConfig = {
  wssServer: "wss://callapi001.limcell.com:8089/ws",
  uri: "sip:3000@callapi001.limcell.com",
  username: "3000",
  password: "abcd1234!.X",
  target:
    "sip:enccaldMG0Ko0syW+0+MmDrDtiHhArzwjJYkm2Ev27G+EMzI5Y=@callapi001.limcell.com",
  iceServers: [
    { urls: "stun:stun.limcell.com:3478" },
    {
      urls: "turn:stun.limcell.com:3478",
      username: "limstunuser",
      credential: "limstunpass123",
    },
  ],
};

interface LiveSupportButtonProps {
  item: FloatingMenuItem;
}

const LiveSupportButton = ({ item }: LiveSupportButtonProps) => {
  const {
    isOpen,
    isConnected,
    callStatus,
    statusMessage,
    open,
    close,
    makeCall,
    hangup,
  } = useLiveSupport(SUPPORT_SIP_CONFIG);

  const { makeCall: makeAiCall } = useAiCall();

  const { isAuthenticated } = useAuth();
  const router = useRouter();
  const pathname = usePathname();
  const buttonRef = useRef<HTMLButtonElement>(null);

  const handleToggle = () => {
    if (!isAuthenticated) {
      router.push(`/auth/login?redirect=${encodeURIComponent(pathname)}`);
      return;
    }
    if (isOpen) {
      close();
    } else {
      trackGeneric("live_support");
      open();
    }
  };

  return (
    <>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            ref={buttonRef} // 👈 KRİTİK
            type="button"
            onClick={handleToggle}
            className="w-10 sm:w-11 lg:w-12 h-10 sm:h-11 lg:h-12 bg-black rounded-xl p-0 relative"
            style={{ backgroundColor: "#f2791c" }}
          >
            <Image src={item.icon} alt={item.title} width={24} height={24} />

            <span
              className={`absolute top-1.5 right-1.5 w-2 h-2 rounded-full ring-2 ring-black ${
                isConnected ? "bg-green-400" : "bg-gray-400"
              }`}
            />
          </Button>
        </TooltipTrigger>

        {item.placeholder && (
          <TooltipContent side="left">
            <p>{item.placeholder}</p>
          </TooltipContent>
        )}
      </Tooltip>

      {isOpen && (
        <LiveSupportDialog
          callStatus={callStatus}
          statusMessage={statusMessage}
          onClose={close}
          onCall={() => { trackGeneric("live_support_call", "click"); makeCall(); }}
          onHangup={() => { trackGeneric("live_support_hangup", "click"); hangup(); }}
          onAiCall={makeAiCall}
          triggerRef={buttonRef}
        />
      )}
    </>
  );
};

export default LiveSupportButton;
